import React, { useState, useEffect } from "react"; 
import { useNavigate } from "react-router-dom"; 
import { motion } from "framer-motion"; 
import { Package, Truck, CheckCircle2, Clock, ArrowLeft, Search, Lock } from "lucide-react"; 

import { db as database, auth } from "./firebase"; 
import { ref, onValue } from "firebase/database";
import { onAuthStateChanged } from "firebase/auth";

export default function Theodoidonhang() { 
  const navigate = useNavigate(); 
  const [myApprovedOrders, setMyApprovedOrders] = useState([]); 
  const [searchTerm, setSearchTerm] = useState(""); 
  
  const [currentUser, setCurrentUser] = useState(null);
  const [loadingAuth, setLoadingAuth] = useState(true);
  const [loadingData, setLoadingData] = useState(true);

  // Inject Font chữ sang trọng (Google Fonts)
  useEffect(() => {
    const link = document.createElement("link");
    link.href = "https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,500;0,600;1,300;1,400&family=Pinyon+Script&family=Montserrat:wght@200;300;400;500;600&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);
  }, []);

  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
      setLoadingAuth(false);
    });
    return () => unsubscribeAuth();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  useEffect(() => {
    if (!currentUser) {
      setLoadingData(false);
      return;
    }

    setLoadingData(true);
    
    // Đã thay đổi đường dẫn gọi dữ liệu trực tiếp tới thư mục bảo mật của cá nhân user
    const ordersRef = ref(database, `user_orders/${currentUser.uid}`);
    
    const unsubscribeData = onValue(ordersRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const ordersArray = Object.keys(data).map((key) => ({
          ...data[key],
          firebaseKey: key,
        }));

        // Hiển thị tất cả đơn hàng, HOẶC chỉ ẩn những đơn đã bị từ chối/hủy hẳn.
        const filteredByAccount = ordersArray.filter((order) => {
          return order.status !== "payment_rejected" && order.status !== "payment_failed";
        });
        
        setMyApprovedOrders(filteredByAccount);
      } else {
        setMyApprovedOrders([]);
      }
      setLoadingData(false);
    }, (error) => {
      console.error("Lỗi bảo mật hoặc đọc Firebase Database:", error);
      setLoadingData(false);
    });

    return () => unsubscribeData();
  }, [currentUser]);

  const filteredOrders = myApprovedOrders.filter((order) => {
    // Ép kiểu ID về chuỗi an toàn vì orderId bây giờ là định dạng số
    const orderIdString = order.id ? String(order.id) : "";
    const orderIdMatch = orderIdString.toLowerCase().includes(searchTerm.toLowerCase());
    const phoneMatch = order.buyer?.phone?.includes(searchTerm) || order.customer?.phone?.includes(searchTerm);
    return orderIdMatch || phoneMatch;
  });

  return ( 
    <div style={styles.container}> 
      <style>{`
        .btn-luxury-back {
          background: none; border: none; color: #666; font-size: 13px; font-weight: 500;
          display: flex; alignItems: center; gap: 8px; cursor: pointer; padding: 0;
          transition: color 0.3s ease;
          font-family: 'Montserrat', sans-serif;
          text-transform: uppercase;
          letter-spacing: 1px;
        }
        .btn-luxury-back:hover { color: #111 !important; }
        
        .luxury-search-input:focus {
          border-color: #111 !important;
        }
        
        @media (max-width: 768px) {
          .order-grid {
            grid-template-columns: 1fr !important;
          }
          .script-title {
            font-size: 38px !important;
          }
          .main-title {
            font-size: 32px !important;
          }
        }
      `}</style>

      <div style={styles.topBackBar}>
        <button onClick={() => navigate("/")} className="btn-luxury-back">
          <ArrowLeft size={16} /> Trở về cửa hàng
        </button>
      </div>

      <header style={styles.header}> 
        <span style={styles.scriptTitle} className="script-title">Order Journey</span>
        <h1 style={styles.mainTitle} className="main-title">Đơn hàng của tôi</h1> 
        <div style={styles.titleDivider}></div>
        <p style={styles.subText}>Theo dõi trạng thái và hành trình các thiết kế hoa độc bản của bạn.</p>
      </header> 

      <div style={styles.contentWrap}> 
        {loadingAuth ? (
          <div style={styles.emptyState}>
            <div style={styles.spinner}></div>
            <p>Đang xác thực tài khoản của bạn...</p>
          </div>
        ) : !currentUser ? (
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} style={styles.loginCard}>
            <Lock size={42} color="#111" style={{ margin: "0 auto 20px" }} />
            <h3 style={styles.loginTitle}>Yêu cầu đăng nhập</h3>
            <p style={styles.loginDesc}>
              Vui lòng đăng nhập tài khoản để có thể xem và quản lý danh sách đơn hàng cá nhân của bạn tại Floraison.
            </p>
            <button onClick={() => navigate("/")} style={styles.btnAction}>
              Đăng nhập ngay
            </button>
          </motion.div>
        ) : (
          <>
            <div style={styles.searchWrapper}> 
              <Search size={18} color="#999" /> 
              <input 
                className="luxury-search-input"
                style={styles.searchInput} 
                placeholder="Tra cứu nhanh theo mã đơn hàng hoặc số điện thoại..." 
                value={searchTerm} 
                onChange={(e) => setSearchTerm(e.target.value)} 
              /> 
            </div> 

            {loadingData ? (
              <div style={styles.emptyState}>
                <div style={styles.spinner}></div>
                <p>Đang đồng bộ đơn hàng cá nhân...</p>
              </div>
            ) : filteredOrders.length === 0 ? ( 
              <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} style={styles.emptyState}> 
                <Package size={50} color="#ccc" style={{ margin: "0 auto 15px", strokeWidth: 1 }} /> 
                <p style={{ fontFamily: '"Montserrat", sans-serif', fontSize: "14px", color: "#666" }}>
                  Tài khoản của bạn chưa có đơn hàng nào được ghi nhận.
                </p> 
              </motion.div> 
            ) : ( 
              <div style={styles.orderGrid} className="order-grid"> 
                {filteredOrders.map((order, index) => ( 
                  <motion.div 
                    initial={{ opacity: 0, y: 30 }} 
                    animate={{ opacity: 1, y: 0 }} 
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                    key={order.id || order.firebaseKey} 
                    style={styles.orderCard} 
                  > 
                    <div style={styles.cardHeader}> 
                      <div style={styles.orderIdWrapper}>
                        <span style={styles.orderIdLabel}>Mã đơn hàng</span>
                        <span style={styles.orderId}>#{order.id}</span> 
                      </div>
                      <div style={{
                        display: "flex", 
                        alignItems: "center", 
                        gap: "6px", 
                        padding: "6px 14px", 
                        borderRadius: "20px", 
                        fontSize: "12px", 
                        fontFamily: '"Montserrat", sans-serif',
                        fontWeight: "600",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        background: order.status === "verified_success" ? "#e8f5e9" : "#fff3e0", 
                        color: order.status === "verified_success" ? "#2e7d32" : "#e65100"
                      }}> 
                        <CheckCircle2 size={14} /> 
                        {order.status === "verified_success" ? "Đã xác nhận" : 
                         order.status === "awaiting_payment" ? "Chờ thanh toán" : 
                         "Đang xử lý"} 
                      </div>
                    </div> 
                    
                    <div style={styles.customerInfo}> 
                      <div style={styles.customerRow}>
                        <span style={styles.infoLabel}>Người nhận:</span>
                        <span style={styles.infoValue}>{order.receiver?.name || order.buyer?.name || order.customer?.name}</span>
                      </div>
                      <div style={styles.customerRow}>
                        <span style={styles.infoLabel}>Địa chỉ:</span>
                        <span style={styles.infoValue}>{order.receiver?.address || order.customer?.address}</span>
                      </div>
                    </div> 
                    
                    <div style={styles.divider}></div> 
                    
                    <div style={styles.itemList}> 
                      {order.items && order.items.map((item, idx) => ( 
                        <div key={idx} style={styles.itemRow}> 
                          <span style={styles.itemName}>{item.quantity}x {item.name}</span> 
                          <span style={styles.itemPrice}>{(item.price * item.quantity).toLocaleString()}đ</span> 
                        </div> 
                      ))} 
                    </div> 
                    
                    <div style={styles.divider}></div> 
                    
                    <div style={styles.cardFooter}> 
                      <div style={styles.totalLabel}>Tổng thanh toán</div> 
                      <div style={styles.totalValue}>{order.total ? order.total.toLocaleString() : "0"}đ</div> 
                    </div> 
                    
                    <div style={styles.timeline}> 
                      <div style={styles.stepActive}>
                        <div style={styles.stepIconWrapActive}><Clock size={12} /></div>
                        Đã đặt hàng
                      </div> 
                      <div style={styles.stepInactive}>
                        <div style={styles.stepIconWrap}><Truck size={12} /></div>
                        Đang chuẩn bị hàng
                      </div> 
                    </div> 
                  </motion.div> 
                ))} 
              </div> 
            )}
          </>
        )}
      </div> 
    </div> 
  ); 
} 

/* ================= JSS STYLING (PHONG CÁCH LUXURY ATELIER) ================= */
const styles = {
  container: { 
    minHeight: "100vh", 
    background: "#faf9f8", // Nền be nhạt sang trọng
    fontFamily: '"Montserrat", sans-serif',
    color: "#111",
    paddingBottom: "80px"
  }, 
  topBackBar: {
    maxWidth: "1140px",
    margin: "0 auto",
    padding: "30px 5% 10px",
  },
  header: { 
    padding: "20px 5% 40px", 
    textAlign: "center", 
  }, 
  scriptTitle: {
    fontFamily: '"Pinyon Script", cursive',
    fontSize: "48px",
    color: "#4a5a3a", // Xanh rêu
    margin: "0 0 -10px 0",
    display: "block",
  },
  mainTitle: { 
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "40px", 
    fontWeight: "400", 
    color: "#111",
    textTransform: "uppercase",
    letterSpacing: "3px",
    margin: "0 0 20px 0"
  }, 
  titleDivider: {
    width: "60px",
    height: "1px",
    backgroundColor: "#111",
    margin: "0 auto 20px",
  },
  subText: {
    fontSize: "13px",
    color: "#666",
    lineHeight: "1.6",
    maxWidth: "500px",
    margin: "0 auto",
  },
  contentWrap: { 
    maxWidth: "1140px", 
    margin: "0 auto", 
    padding: "0 5%" 
  }, 
  searchWrapper: { 
    display: "flex", 
    alignItems: "center", 
    gap: "12px", 
    background: "#fff", 
    padding: "16px 20px", 
    border: "1px solid #eaeaea",
    borderRadius: "2px", // Gọn gàng, hơi vuông vắn theo chuẩn luxury
    marginBottom: "40px",
    maxWidth: "600px",
    margin: "0 auto 40px"
  }, 
  searchInput: { 
    border: "none", 
    outline: "none", 
    width: "100%", 
    fontSize: "13px",
    fontFamily: '"Montserrat", sans-serif',
    background: "transparent"
  }, 
  orderGrid: { 
    display: "grid", 
    gridTemplateColumns: "repeat(2, 1fr)", // Chia 2 cột trên Desktop
    gap: "30px" 
  }, 
  orderCard: { 
    background: "#fff", 
    padding: "35px 30px", 
    borderRadius: "2px", 
    border: "1px solid #eaeaea",
    boxShadow: "0 10px 30px rgba(0,0,0,0.02)",
    display: "flex",
    flexDirection: "column"
  }, 
  cardHeader: { 
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "flex-start", 
    marginBottom: "25px" 
  }, 
  orderIdWrapper: {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  },
  orderIdLabel: {
    fontSize: "10px",
    color: "#888",
    textTransform: "uppercase",
    letterSpacing: "1.5px"
  },
  orderId: { 
    fontFamily: '"Cormorant Garamond", serif',
    fontWeight: "600", 
    color: "#111", 
    fontSize: "22px",
    letterSpacing: "1px"
  }, 
  customerInfo: { 
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    marginBottom: "20px", 
  }, 
  customerRow: {
    display: "flex",
    fontSize: "13px",
    lineHeight: "1.5"
  },
  infoLabel: {
    color: "#666",
    width: "90px",
    flexShrink: 0
  },
  infoValue: {
    color: "#111",
    fontWeight: "500"
  },
  divider: { 
    height: "1px", 
    background: "#f0f0f0", 
    margin: "15px 0" 
  }, 
  itemList: { 
    display: "flex", 
    flexDirection: "column", 
    gap: "12px",
    flexGrow: 1
  },
  itemRow: { 
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "flex-start",
    gap: "15px"
  }, 
  itemName: {
    fontSize: "13px", 
    color: "#444",
    lineHeight: "1.5"
  },
  itemPrice: {
    fontSize: "13.5px",
    fontWeight: "500",
    color: "#111"
  },
  cardFooter: { 
    display: "flex", 
    justifyContent: "space-between", 
    alignItems: "center",
    marginTop: "5px"
  }, 
  totalLabel: { 
    color: "#666", 
    fontSize: "12px",
    textTransform: "uppercase",
    letterSpacing: "1px",
    fontWeight: "500"
  }, 
  totalValue: { 
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "18px", 
    fontWeight: "600", 
    color: "#d4af37" // Vàng gold điểm nhấn
  }, 
  timeline: { 
    marginTop: "25px", 
    display: "flex", 
    gap: "20px", 
    background: "#faf9f8",
    padding: "15px 20px",
    borderRadius: "2px",
    border: "1px solid #f0f0f0"
  }, 
  stepActive: { 
    display: "flex", 
    alignItems: "center", 
    gap: "8px", 
    fontSize: "12px", 
    color: "#111",
    fontWeight: "500"
  }, 
  stepInactive: { 
    display: "flex", 
    alignItems: "center", 
    gap: "8px", 
    fontSize: "12px", 
    color: "#999",
  }, 
  stepIconWrapActive: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "22px",
    height: "22px",
    borderRadius: "50%",
    background: "#111",
    color: "#fff"
  },
  stepIconWrap: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "22px",
    height: "22px",
    borderRadius: "50%",
    background: "#eee",
    color: "#999"
  },
  emptyState: { 
    textAlign: "center", 
    padding: "80px 20px", 
    color: "#888",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "14px"
  }, 
  loginCard: {
    background: "#fff",
    padding: "50px 40px",
    borderRadius: "2px",
    border: "1px solid #eaeaea",
    maxWidth: "500px",
    margin: "40px auto",
    textAlign: "center",
    boxShadow: "0 10px 40px rgba(0,0,0,0.03)"
  },
  loginTitle: {
    fontFamily: '"Cormorant Garamond", serif',
    fontSize: "28px",
    fontWeight: "400",
    color: "#111",
    margin: "0 0 15px 0"
  },
  loginDesc: {
    fontSize: "13px",
    color: "#666",
    lineHeight: "1.6",
    marginBottom: "30px"
  },
  btnAction: {
    padding: "14px 35px",
    background: "#111",
    color: "#fff",
    border: "none",
    fontFamily: '"Montserrat", sans-serif',
    fontSize: "11px",
    textTransform: "uppercase",
    letterSpacing: "2px",
    cursor: "pointer",
    transition: "background 0.3s ease"
  },
  spinner: {
    width: "30px",
    height: "30px",
    border: "2px solid rgba(0,0,0,0.1)",
    borderTop: "2px solid #111",
    borderRadius: "50%",
    margin: "0 auto 15px",
    animation: "spin 1s linear infinite"
  }
};